import React from 'react';
import _ from 'underscore';
import Helmet from 'react-helmet';
import 'typeface-lato';
import 'typeface-montserrat';
import { func } from 'prop-types';
import Footer from '../components/Footer';

import favicon from '../assets/favicon.png';
import '../styles/global.styl';
import styles from '../styles/app.module.styl';

const Layout = ({ children, data, location, ...props }) => {
  const {
    title,
    logoTitle,
    dpa_link,
    tos_link,
    privacy_link,
    cookies_link,
    copyright,
  } = data.site.siteMetadata;

  const edges = data.allJsonContentsJson.edges;
  const nodeData = edges && !_.isEmpty(props.layoutContext) ? edges[0].node : {};
  return (
    <div className={styles.page}>
      <Helmet
        title={title}
        link={[{ rel: 'shortcut icon', type: 'image/png', href: `${favicon}` }]}
      />
      <div className={styles.content}>{children()}</div>
      <Footer
        logoTitle={logoTitle}
        copyright={copyright}
        tos_link={tos_link}
        dpa_link={dpa_link}
        cookies_link={cookies_link}
        privacy_link={privacy_link}
      />
    </div>
  );
};

Layout.propTypes = {
  children: func,
};

export default Layout;

export const query = graphql`
  query LayoutQuery($pageId: String) {
    allJsonContentsJson(filter: { pageId: { eq: $pageId } }) {
      edges {
        node {
          pageId
          logo
          title
          groups {
            name
            title
          }
        }
      }
    }
    site {
      siteMetadata {
        title
        logoTitle
        copyright
        tos_link
        dpa_link
        cookies_link
        privacy_link
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/index.js